import useMediaQuery from '@mui/material/useMediaQuery';

import { theme } from '../theme/theme';

function useIsMobile(breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl') {
  const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint ?? 'sm'));
  return isMobile;
}

export default useIsMobile;
